import { Col } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";

export interface DeviceOptionsEmptyProps {
  supportTicketHref: string;
}

export const DeviceOptionsEmpty: FC<DeviceOptionsEmptyProps> = ({ supportTicketHref }) => (
  <Col gridGap="S300">
    <Text>{getString("replacement.chooseDevice.empty")}</Text>
    <Link href={supportTicketHref} target="_blank" rel="noopener noreferrer">
      {getString("replacement.chooseDevice.generateSupportTicket")}
    </Link>
  </Col>
);
